'use client'

import { useTranslations } from 'next-intl'
import { useState } from 'react'

import { COMMENTS_SORT_OPTIONS } from '@/app/[locale]/[roomId]/components/CommentsPanel'
import SortIcon from '@/components/assets/icon_sort.svg'
import PopoverMenu from '@/components/PopoverMenu'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import ViverseButton from '@/components/ViverseButton'
import { cn } from '@/lib/utils'
import { SortOptionValue } from '@/types/comments'

type SortPopoverButtonProps = {
  sortOrder: SortOptionValue
  setSortOrder: (sortOrder: SortOptionValue) => void
}

function SortPopoverButton({ sortOrder, setSortOrder }: SortPopoverButtonProps) {
  const t = useTranslations()
  const [open, setOpen] = useState(false)

  return (
    <>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <ViverseButton
            className={cn(
              'flex cursor-pointer items-center gap-2 bg-transparent px-4 py-1.5',
              open && 'bg-vive-primary-70',
            )}
            onClick={() => setOpen(true)}
            variant="filter"
          >
            <SortIcon className={cn(open ? 'fill-primary' : 'fill-vive-primary-20')} />
            <span className={cn('buttonS-omni-styles', open && 'text-primary')}>
              {t(`sort-popover.item.${COMMENTS_SORT_OPTIONS[sortOrder].label}`)}
            </span>
          </ViverseButton>
        </PopoverTrigger>
        <PopoverContent side="bottom" className="mt-2 border-none bg-transparent p-0">
          <PopoverMenu className="bg-vive-primary-70 rounded-[3px] p-2">
            <PopoverMenu.Group>
              <PopoverMenu.Item
                className="rounded-none"
                onClick={() => {
                  setSortOrder(COMMENTS_SORT_OPTIONS['top'].value)
                  setOpen(false)
                }}
              >
                <div className="body-1 text-inherit">{t('sort-popover.item.top-comments')}</div>
              </PopoverMenu.Item>
              <PopoverMenu.Item
                className="rounded-none"
                onClick={() => {
                  setSortOrder(COMMENTS_SORT_OPTIONS['latest'].value)
                  setOpen(false)
                }}
              >
                <div className="body-1 text-inherit">{t('sort-popover.item.latest')}</div>
              </PopoverMenu.Item>
            </PopoverMenu.Group>
          </PopoverMenu>
        </PopoverContent>
      </Popover>
    </>
  )
}

export default SortPopoverButton
